/**
 * Comportamiento de scroll a usar en desplazamientos programáticos: `smooth`
 * por defecto, salvo que el usuario haya pedido reducir el movimiento
 * (`prefers-reduced-motion: reduce`), en cuyo caso se salta sin animación.
 *
 * SSR-safe: fuera del browser (o sin `matchMedia`) devuelve `auto` para no
 * tocar APIs de DOM inexistentes.
 */
export function scrollBehavior(): ScrollBehavior {
  if (typeof window === 'undefined' || !window.matchMedia) return 'auto';
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}
